import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import CommissionForm from '../EditCommissionForm'
import NavigateBackButton from '@/common/components/NavigateBackButton'

export default function EditCommissionListing() {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title={`แก้ไขรายการคอมมิชชั่น`}
					description="แก้ไขรายการคอมมิชชั่น"
				/>
				<NavigateBackButton />
			</div>
			<Separator />
			<CommissionForm />
		</div>
	)
}
